
import projectStyles from "./project.module.less";
import React, {useEffect, useRef, useState} from "react";
import { message, Col, Row, Input, ConfigProvider, Pagination, Progress } from 'antd';
import { TeamOutlined, UserOutlined, BarChartOutlined, SearchOutlined, ForkOutlined,} from '@ant-design/icons';
import zhCN from 'antd/lib/locale/zh_CN';


import studentempty from "../../static/image/studentempty@2x.png";

import {BACKEND_API_URL } from '../../constants/constants';

import "./project-split-pane.css";
import { sendHttpPostRequest } from "../../api/http-request";
import Cookies from "js-cookie";



/** 学生教室页面 */
export interface Props {
    classroom_id: string | number,
    college_id:any,
    course_id:any,
    course_name: any,
    role: any, // student, teacher
}
const ProjectMyClassroom :React.FC<Props> = (props)=>{

    const {classroom_id,college_id,course_id,course_name, role} = props;
  
    const [classRoomInfo, setClassRoomInfo] = useState(null as any);//班级信息
    const [classStudentList, setClassStudentList] = useState(null as any);//班级学生列表
    const [classStudentTotalCount, setClassStudentTotalCount] = useState(null as any);//班级学生总数
    const [classStudentResultSum, setClassStudentResultSum] = useState(null as any);//满足查询条件的学生数量


    const page = useRef(1);//当前学生页
    const pageSize = useRef(12);//每页学生数量
    const queryStudentContent = useRef("");//查询字符串




    useEffect(()=> {
        queryClassRoom();
    }, []);

    /** 查询班级信息 */
    const queryClassRoom = () => {

    sendHttpPostRequest(
        role=='student'? 'classroom/api/student_query_classroom_by_id' : 'classroom/api/user_query_classroom_by_id/',
        {
            sessionid: Cookies.get("sessionid"),
            classroom_id: classroom_id,
            college_id:college_id,
            course_id:course_id,
            query: queryStudentContent.current,
            page: page.current,
            pagesize: pageSize.current
        },
        (response: any) => {
            message.destroy();
            if (response.code == -100) {
                // 未登录
                document.getElementById("show-login-modal")!.click();
            } else if (response.is_ok == true) {
                setClassRoomInfo(response.query_info);
                setClassStudentList(response.query_info.student_list);
                setClassStudentTotalCount(response.student_total_count);
                setClassStudentResultSum(response.student_result_sum);
                   
            } /*else if (response.code == -501) {
                权限不足
                window.location.href = '/oam_login?next=oam_menu';
            } */else {
                message.error(response.message);
            }
        }
    )
}


    //页码和页数发生了变化
    const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
        page.current = newPage ? newPage : 1;
        if (newPageSize) {
            pageSize.current = newPageSize;
        }
        queryClassRoom();
    }



    const onQueryContentChange = (event: any) => {
        queryStudentContent.current = event.target.value
    }

    //点击了搜索按钮
    const onSearchBtn = () => {
        page.current = 1
        queryClassRoom()
    }

    return ( 
        <div>
            {/* === 顶部 Banner：班级信息 + 教师 + 统计 === */}
            <div className={projectStyles.studentClassHeaderDiv}>
                <div style={{position:'absolute', top:0, right:0, opacity:0.08, pointerEvents:'none'}}>
                    <ForkOutlined rotate={40} style={{position:'absolute',top:-30, right:-50,fontSize:'160px', color:'#4f46e5'}}/>
                </div>

                <Row gutter={[24, 16]} align={'middle'} style={{position:'relative', zIndex:1}}>
                    {/* 左侧：班级名 + 描述 + 教师 */}
                    <Col xs={24} md={10}>
                        <div className={projectStyles.studentClassName}>{classRoomInfo?.name}</div>
                        <div className={projectStyles.studentClassDesp}>
                            <span className={projectStyles.studentClassDespTag}>班号 {classRoomInfo?.number}</span>
                            <span className={projectStyles.studentClassDespTag}>创建 {classRoomInfo?.create_time}</span>
                            <span className={projectStyles.studentClassDespTag}>学员 {classStudentTotalCount}</span>
                        </div>
                        <div className={projectStyles.studentClassTeacherBadge}>
                            <img src={classRoomInfo?.teacher_avatar?.startsWith("http") ? classRoomInfo?.teacher_avatar : BACKEND_API_URL + classRoomInfo?.teacher_avatar} className={projectStyles.studentClassTeacherAvatar}/>
                            <div>
                                <div style={{fontSize:14, fontWeight:600, color:'#1e293b'}}>
                                    {classRoomInfo?.teacher_real_name ? classRoomInfo?.teacher_real_name : classRoomInfo?.user_name}
                                </div>
                                <div style={{fontSize:12, color:'#6366f1'}}>指导教师</div>
                            </div>
                        </div>
                    </Col>

                    {/* 右侧：4个统计指标 */}
                    <Col xs={24} md={14}>
                        <Row gutter={[12, 12]}>
                            <Col xs={12} sm={6}>
                                <div className={projectStyles.studentStatCard}>
                                    <div className={projectStyles.studentStatLabel}>已完成学员</div>
                                    <div className={projectStyles.studentStatValue} style={{color:'#4f46e5'}}>{classRoomInfo?.complete_count}</div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6}>
                                <div className={projectStyles.studentStatCard}>
                                    <div className={projectStyles.studentStatLabel}>未完成学员</div>
                                    <div className={projectStyles.studentStatValue} style={{color:'#f59e0b'}}>{classRoomInfo?.process_count}</div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6}>
                                <div className={projectStyles.studentStatCard}>
                                    <div className={projectStyles.studentStatLabel}>平均任务进度</div>
                                    <div className={projectStyles.studentStatValue} style={{color:'#4f46e5'}}>{classRoomInfo?.task_avg_percent}%</div>
                                    <Progress size="small" showInfo={false} strokeColor='#4f46e5' trailColor={'rgba(255,255,255,0.5)'} percent={classRoomInfo?.task_avg_percent} />
                                </div>
                            </Col>
                            <Col xs={12} sm={6}>
                                <div className={projectStyles.studentStatCard}>
                                    <div className={projectStyles.studentStatLabel}>平均报告进度</div>
                                    <div className={projectStyles.studentStatValue} style={{color:'#10b981'}}>{classRoomInfo?.report_avg_percent}%</div>
                                    <Progress size="small" showInfo={false} strokeColor='#10b981' trailColor={'rgba(255,255,255,0.5)'} percent={classRoomInfo?.report_avg_percent} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>

            {/* === 班级学员列表（全宽） === */}
            <div className={projectStyles.studentClassMemberWrapper}>
                <Row className={projectStyles.studentClassDivTitle} wrap={false} align={'middle'} style={{margin: '0 0 16px'}}>
                    <Col flex={'auto'} style={{textAlign:'left'}}>
                        <TeamOutlined style={{marginRight:8, color:'#4f46e5'}}/> 班级学员
                    </Col>
                    <Col flex={'300px'} style={{textAlign:'right'}}>
                        <Input
                            onPressEnter={onSearchBtn}
                            onChange={onQueryContentChange}
                            placeholder="搜索学员..."
                            prefix={<SearchOutlined />}
                            style={{borderRadius:8, width:'100%', maxWidth:300}}
                            className={projectStyles.studentSearchInput}
                        />
                    </Col>
                </Row>

                <Row gutter={[16,16]}>
                    {classStudentList?.map((student,index)=>(
                        <Col xs={24} sm={12} md={8} lg={6} xl={6} xxl={4} key={index}>
                            <div className={projectStyles.studentCard}>
                                {student?.report_complete_percent == 100 && student?.task_complete_percent == 100 && <span className={projectStyles?.studentCompleteStatus} style={{padding:'2px 8px', color: '#fff', background:'#22c55e', borderRadius:999}}>已完成</span>}
                                <Row wrap={false} justify="start" align={"middle"} gutter={16} style={{marginBottom:16}}>
                                    <Col flex={'56px'}>
                                        <div className={projectStyles.studentCardHeader}>
                                            <img src={student.avatar?.startsWith("http") ? student.avatar : BACKEND_API_URL + student.avatar} style={{width:'100%', height:'100%', objectFit: 'cover', borderRadius:8}}/>
                                        </div>
                                    </Col>
                                    <Col flex={'auto'}>
                                        <div style={{textAlign:'left', paddingLeft: 4}}>
                                            <div className={projectStyles.studentCardName}>
                                                {student?.real_name == "" ? student?.user_name : student?.real_name}
                                            </div>
                                            <div className={projectStyles.studentCardXuehao} style={{height:20}}>
                                                学号: {student?.number}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                <Row align={"middle"} gutter={8}>
                                    <Col span={12} style={{textAlign:'left', color: '#6b7280'}}><div>任务进度</div></Col>
                                    <Col span={12} style={{textAlign:'right', color: '#6b7280'}}><div>{student?.task_complete_percent}%</div></Col>
                                </Row>
                                <div style={{textAlign:'left', color: '#6b7280', marginBottom:12}}><Progress showInfo={false} width={20} strokeColor='#4f46e5' trailColor={'#4f46e51a'} percent={student?.task_complete_percent} /></div>

                                <Row align={"middle"} gutter={8}>
                                    <Col span={12} style={{textAlign:'left', color: '#6b7280'}}><div>报告进度</div></Col>
                                    <Col span={12} style={{textAlign:'right', color: '#6b7280'}}><div>{student?.report_complete_percent}%</div></Col>
                                </Row>
                                <div style={{textAlign:'left', color: '#6b7280'}}><Progress width={20} showInfo={false} strokeColor='#10b981' trailColor={'#10b9811a'} percent={student?.report_complete_percent} /></div>
                            </div>
                        </Col>
                    ))}
                </Row>

                <ConfigProvider locale={zhCN}>
                    <div style={{marginBottom:20, paddingTop:20, textAlign:"center"}}>
                        <Pagination
                            defaultCurrent={1}
                            total={classStudentResultSum}
                            defaultPageSize={pageSize.current}
                            current={page.current}
                            hideOnSinglePage={true}
                            onChange={onPageChange}
                        />
                    </div>
                </ConfigProvider>
            </div>
        </div>
    )

    }

export default ProjectMyClassroom